export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              关于番茄漫画
            </h2>
            <p className="text-sm text-foreground-500">专注漫画追更，让阅读更简单</p>
          </div>

          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                番茄漫画诞生于对漫画的热爱——我们是一群资深漫画读者，深知追更等待的煎熬和找不到好漫画的困扰。
                因此，我们创建了这个聚合平台，致力于为所有漫画爱好者提供全网最全、最快、最流畅的追漫体验。
              </p>
              <p>
                目前平台已收录超过 <strong className="text-primary-600 font-semibold">2000 部</strong>漫画作品，涵盖韩漫、日漫、国漫三大品类，
                覆盖热血、恋爱、奇幻、悬疑、搞笑、BL/GL 等全类型。每天有数十万读者在番茄漫画上追更阅读。
              </p>
              <p>
                我们坚持<strong className="text-accent-600 font-semibold">全免费</strong>模式，不设付费墙，不限制阅读章节数。
                同时持续优化下拉式滚动阅读体验，引入追漫提醒、离线缓存、夜间模式等贴心功能，只为让你追漫更轻松。
              </p>
              <p>
                番茄漫画始终相信：好的漫画值得被更多人看到。欢迎每一位热爱漫画的你，和我们一起打造最好的追漫社区。
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              <div>
                <div className="text-2xl font-heading font-bold text-primary-600">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div>
                <div className="text-2xl font-heading font-bold text-accent-600">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活读者</div>
              </div>
              <div>
                <div className="text-2xl font-heading font-bold text-primary-600">2小时</div>
                <div className="text-xs text-foreground-500 mt-1">最快同步</div>
              </div>
              <div>
                <div className="text-2xl font-heading font-bold text-accent-600">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无付费墙</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}